<template>
  <div>
    <!-- 右侧固定栏 -->
    <div class="Sidebar">
      <div class="box1">
        <div class="picture5" id="div1">
          <!-- :href="registerAddress" -->
          <a :href="AdData.registerAddress" target="_blank">
            <img src="@/static/common/zhuce.png" style="width:30px; height:30px; vertical-align: text-bottom;position: absolute;left: 29%;top: 10px;">
            <p style="width:100%;font-size: 14px;color: #fff;position: absolute;bottom: 4px;text-align: center;">用户注册</p>
          </a>
        </div>
      </div>
      <div class="box2">
        <div class="picture6" id="div5">
          <!-- :href="address" -->
          <a :href="AdData.loginAddress" target="_blank">
            <img src="@/static/common/denglu.png" style="width:30px; height:30px; vertical-align: text-bottom;position: absolute;left: 29%;top: 10px;">
            <p style="width:100%;font-size: 14px;color: #fff;position: absolute;bottom: 4px;text-align: center;">系统登录</p>
          </a>
        </div>
      </div>
      <div class="box3" style="display: flex;justify-content: flex-end;margin-top: 9px;cursor: pointer;">
        <div class="title1" id="div3">
          <div class="title1-box">
            <p style="margin:0; margin-left:10px; font-size:18px; margin-bottom:5px;">{{AdData.phone}}</p>
            <p style="margin:0; margin-left:10px; font-size:18px;">(工作日8:30-12:00，14:00-17:30)</p>
          </div>
        </div>
        <div class="picture7" id="div4" @mousemove="pop">
          <img src="@/static/common/dianhua.png" style="width:30px; height:30px; vertical-align: text-bottom;position: absolute;left: 29%;top: 10px;">
          <p style="width:100%;font-size: 14px;color: #fff;position: absolute;bottom: 4px;text-align: center;">联系电话</p>
        </div>
      </div>
      <div class="box4" style="display: flex;justify-content: flex-end;margin-top: 9px;">
        <div class="title1" id="div7">
          <div class="title1-box">
            <p style="margin:0; margin-left:10px; font-size:18px; margin-bottom:5px;">{{AdData.lineQq}}</p>
            <p style="margin:0; margin-left:10px; font-size:18px;">(工作日8:30-12:00，14:00-17:30)</p>
          </div>
        </div>
        <div class="picture8" id="div8" @mousemove="pop1">
          <img src="@/static/common/QQ.png" style="width:30px; height:30px; vertical-align: text-bottom;position: absolute;left: 29%;top: 10px;">
          <p style="width:100%;font-size: 14px;color: #fff;position: absolute;bottom: 4px;text-align: center;">在线客服</p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { mainStore } from "@/store";
import { queryCmsSiteInfo } from "@/api/index.js";
export default {
  setup() {
    const AdData = ref({})
    const arr = async () => {
      let res = await queryCmsSiteInfo()
      AdData.value = res.data
    }
    onMounted(async () => {
      await arr()
    })
    return {
      AdData,
      arr,
      scrollTop: 0,
      navgatorPath: '',
      // listBoxState: true,//点击导航栏时，暂时停止监听页面滚动
    };
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop); //监听滚动条
    if (localStorage.getItem('toHelpCenter') == 2) {
      localStorage.removeItem('toHelpCenter')
      this.$parent.toHelpCenter()
    }
  },
  unmounted() {
    window.removeEventListener("scroll", this.scrollToTop); //移除滚动条监听
  },
  methods: {
    goToRegister() {
      window.open(process.env.VUE_APP_SEVERCE_REGISTER, "_blank");
    },
    goToLogin() {
      window.open(process.env.VUE_APP_SEVERCE_PLATFORM, "_blank");
    },
    pop() {
      var oDiv = document.getElementById("div4");
      var oD = document.getElementById("div3");
      oDiv.onmouseover = function () {
        oD.style.display = "block"
      };
      oDiv.onmouseout = function () {
        oD.style.display = "none"
      };
    },
    pop1() {
      var oDiv = document.getElementById("div8");
      var oD = document.getElementById("div7");
      oDiv.onmouseover = function () {
        oD.style.display = "block"
      };
      oDiv.onmouseout = function () {
        oD.style.display = "none"
      };
    },
    handleToCaApply() {
      const store = mainStore();
      if (window.location.pathname.indexOf('CaApply') === -1) {
        this.$router.push('/CaApply');
        store.setactivePageUrl('/CaApply');
      }
    },
    handleToHelpCenter() {
      const store = mainStore();
      const router = useRouter();
      if (window.location.pathname.indexOf('index') != -1) {
        this.$parent.toHelpCenter()
      } else {
        this.$router.push('/index');
        localStorage.setItem('toHelpCenter', 2)
        store.setactivePageUrl('/index');
      }
    },
    toBottom() {
      let timer = setInterval(() => {
        let ispeed = Math.floor(document.documentElement.scrollHeight / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          this.scrollTop + ispeed;
        if (this.scrollTop === document.documentElement.scrollHeight - document.documentElement.clientHeight) {
          clearInterval(timer);
        }
      }, 30);
    },
    // 监听到的滚动的距离
    scrollToTop() {
      this.scrollTop =
        window.scrollY ||
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
    },
    // 点击回到顶部方法，加计时器是为了过渡顺滑
    backTop() {
      let timer = setInterval(() => {
        let ispeed = Math.floor(-this.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          this.scrollTop + ispeed;
        if (this.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
      // 直接上移至顶部
      // document.documentElement.scrollTop = document.body.scrollTop = 0;
    },
  }
};
</script>

<style >
@import url("./RightNav.css");
</style>